export default function dsAddCustom(action){
    this.dataStack.push(action);
}